import React, { type ReactElement } from 'react';

import EmailLeadCapture from '@components/EmailLeadCapture';
import useWindowSize from '@hooks/useWindowSize';
import { READER_URL } from '@src/env';
import { FormLocation, LeadTypes } from '@utils/enums';

import { PaywallProps } from '../';

const VERTICAL_STACK_MIN_WIDTH = 768;

const PaywallFullBleedForm = ({
  articleId,
  buttonText = 'Get started',
  briefingGuid,
  leadType = LeadTypes.Paywall,
  isPro,
  offerLink,
  shareGuid,
  unlockContent,
}: PaywallProps): ReactElement => {
  const redirectToOnSuccess = `${READER_URL}${offerLink}`;
  const { width: windowWidth } = useWindowSize();

  return (
    <div className="flex w-full flex-col flex-nowrap content-center items-center justify-center pb-16 md:items-start md:justify-start">
      <div className="mt-16 w-full sm:mt-24 sm:w-[432px]">
        <EmailLeadCapture
          articleId={articleId}
          buttonClassName="w-full md:w-auto"
          buttonText={buttonText}
          briefingGuid={briefingGuid}
          formClassName="mb-0"
          formLocation={FormLocation.Paywall}
          inputClassName="w-full sm:w-[240px] md:w-full"
          isPro={isPro}
          isVertical={windowWidth < VERTICAL_STACK_MIN_WIDTH}
          leadType={leadType}
          redirectToOnSuccess={offerLink}
          shareGuid={shareGuid}
          signInOptionClass="text-center md:text-left"
          gdprClassName="mb-16"
          unlockContent={unlockContent}
          withOauth
          withOnlyOauthExpandable
          oauthRedirectToOnSuccess={redirectToOnSuccess}
        />
      </div>
    </div>
  );
};

export default PaywallFullBleedForm;
